import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Tabs, Tab, Box } from "@mui/material";
import axios from "axios";
import { getToken } from "../../../utils/auth";
import Cookies from 'js-cookie';
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const PlanCard = ({ plan, currencySymbol }) => {
  const formatFeatureName = (name) => {
    return name
      ?.replace(/([A-Z])/g, " $1")
      .trim()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const renderFeatures = (features) => {
    return (
      <ul>
        {features?.map(([feature, value]) => (
          <div key={feature} style={{ fontSize: "18px" }}>
            {/* {value ? (
              <span style={{ color: "green", fontSize: "20px" }}>✔</span>
            ) : (
              <span style={{ color: "red", fontSize: "20px" }}>❌</span>
            )}{" "} */}
            {/* {formatFeatureName(feature)} */}
          </div>
        ))}
      </ul>
    );
  };

  const trueFeatures = [];
  const falseFeatures = [];
  for (const [feature, value] of Object.entries(plan)) {
    if (typeof value === "boolean" && feature !== "isDeleted") {
      if (value) {
        trueFeatures.push([feature, value]);
      } else {
        falseFeatures.push([feature, value]);
      }
    }
  }

  return (
    <Card
      style={{
        width: "95%",
        border: "1px solid #a5a5a5",
        margin: "10px",
        overflowX: "hidden",
      }}
    >
      <Card.Body
        style={{
          // backgroundColor: `${plan?.isEnrolled ? "#ff9b8a" : ""}`,
        }}
      >
        <Card.Title style={{ fontSize: "24px", textAlign: "Center" }}>
          {plan?.serviceName}
        </Card.Title>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("unitRate")}:</strong> {currencySymbol} {plan?.unitRate}
        </Card.Text>
        {plan?.minimumQuantity && (
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("minimumQuantity")}:</strong> {plan?.minimumQuantity}
        </Card.Text>)}
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("serviceType")}:</strong>{" "}
          {plan?.serviceType}
        </Card.Text>
        <Card.Text style={{ fontSize: "18px" }}>
          <strong>{t("description")}:</strong> {plan?.description}
        </Card.Text>
        
        {/* {plan?.isEnrolled && (<>
            <hr />
                        <span style={{ color: "green", fontSize: "20px", justifyContent:"center", display:"flex" }}>✔ Enrolled</span>
                        </>
        )} */}
        {/* {!plan?.isEnrolled && (
          <Button className="px-3" style={{ margin: "auto", display:"flex" }}>
            Buy Now
          </Button>
        )} */}
      </Card.Body>
    </Card>
  );
};

const Topup = () => {
   const { t, i18n } = useTranslation();
  const [plans, setPlans] = React.useState([]);
  const [tabValue, setTabValue] = React.useState(0);
  const defaultCurrency = "USD"; 
  const defaultSymbol = "$";
const [currencies, setCurrencies] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(
        localStorage.getItem("selectedCurrency") || defaultCurrency
    );
    const [currencySymbol, setCurrencySymbol] = useState(
        localStorage.getItem("currencySymbol") || defaultSymbol
    );
  const [user, setUser] = useState("");
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response?.data?.data);
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, []);

    useEffect(() => {
      const savedCurrency = localStorage.getItem("selectedCurrency");
          if (user?.isCookieConsent) {
            Cookies.set("currency", savedCurrency, { expires: 30 });
          }
      // Set default values in localStorage if not already set
      if (!localStorage.getItem("selectedCurrency")) {
          localStorage.setItem("selectedCurrency", defaultCurrency);
if (user?.isCookieConsent) {
        Cookies.set("currency", defaultCurrency, { expires: 30 });
      }      }
      if (!localStorage.getItem("currencySymbol")) {
          localStorage.setItem("currencySymbol", defaultSymbol);
      }
  
      const fetchCurrencies = async () => {
          const url = `${process.env.REACT_APP_URL_ECOMMERCE}/wp-json/wc/v3/data/currencies`;
          const authHeader = "Basic YWRtaW46aTVJTyA5aEZyIGFIU00gOUtVVCBuc2pYIFFOb3A=";
  
          try {
              const response = await axios.get(url, {
                  headers: {
                      Authorization: authHeader,
                  },
              });
              setCurrencies(response.data);
  
              // Check if the saved currency exists in the fetched data
              const savedCurrency = localStorage.getItem("selectedCurrency");
              const savedCurrencyData = response.data.find(
                  (currency) => currency.code === savedCurrency
              );
  
              if (savedCurrencyData) {
                  setCurrencySymbol(decodeHtmlEntity(savedCurrencyData.symbol));
              } else {
                  setCurrencySymbol(defaultSymbol);
              }
          } catch (error) {
              console.error("Error fetching currencies:", error);
          }
      };
  
      fetchCurrencies();
  }, []);
  
      const cookiesPut = async (selectedCode) => {
        try {
          const token = getToken();
          const response = await axios.put(
            `${process.env.REACT_APP_URL}/api/user/cookies`,
            {currency:selectedCode},
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );
          // console.log("User preferences stored successfully")
        } catch (error) {
          console.log("Failed fetching connection", error);
        }
      };

  const handleCurrencyChange = (event) => {
      const selectedCode = event.target.value;
      setSelectedCurrency(selectedCode);
  
      // Save the selected currency to localStorage
      localStorage.setItem("selectedCurrency", selectedCode);
  if (user?.isCookieConsent) {
        Cookies.set("currency", selectedCode, { expires: 30 });
        cookiesPut(selectedCode);
      }
      const selectedCurrencyData = currencies.find(
          (currency) => currency.code === selectedCode
      );
      if (selectedCurrencyData) {
          const symbol = decodeHtmlEntity(selectedCurrencyData.symbol);
          setCurrencySymbol(symbol);
  
          // Save the currency symbol to localStorage
          localStorage.setItem("currencySymbol", symbol);
      }
  
  };
  
  
  const decodeHtmlEntity = (str) => {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = str;
      return textarea.value;
  };

  React.useEffect(() => {
    fetchPlans("sms");
  }, []);

  const fetchPlans = async (platform) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/plan/top-up-rates/by-service-type?serviceType=${platform}&currency=${selectedCurrency}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPlans(response.data.data || []);
    } catch (error) {
      console.log(`Failed fetching Topup for ${platform}`, error);
      setPlans([]); // Set to empty array if there's an error
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        fetchPlans("sms");
        break;
      // case 1:
      //   fetchPlans("dynamicQR");
      //   break;
      // case 2:
      //   fetchPlans("notification");
      //   break;
      case 1:
        fetchPlans("whatsapp");
        break;
      default:
        break;
    }
  };

  return (
    <div>
       {/* <div style={{ textAlign: "right", margin: "10px" }}>
       <select
          value={selectedCurrency}
          onChange={handleCurrencyChange}
          style={{ padding: "5px", fontSize: "16px", width: "200px" }}
        >
          <option value="" disabled>
                                                Select Currency
                                            </option>
                                            {currencies?.map((currency) => (
                                                <option
                                                    key={currency?.code}
                                                    value={currency?.code}
                                                >
                                                    {currency?.name} ({decodeHtmlEntity(currency?.symbol)})
                                                    </option>
                                            ))}
        </select>
      </div> */}
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Tabs value={tabValue} onChange={handleTabChange} centered>
          <Tab label="SMS" />
          {/* <Tab label="Dynamic QRC" />
          <Tab label="Notification" /> */}
          <Tab label="WhatsApp" />
        </Tabs>
      </Box>

      {plans.length > 0 ? (
        <Row>
          {plans.map((plan, index) => (
            <Col key={index} xs={12} md={6}>
              <PlanCard plan={plan} currencySymbol={currencySymbol}/>
              </Col>
          ))}
        </Row>
      ) : (
        <div style={{ textAlign: "center", marginTop: "20px", fontSize: "20px" }}>
          {t("noTopupAvailable")}
        </div>
      )}
    </div>
  );
};

export default Topup;
